import React, { useMemo, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { isBannerDateActual } from "../../../helpers/isBannerDateActual";
import { Box, IconButton, Stack, useTheme } from "@mui/material";
import useHasWindow from "../../../helpers/useHasWindow";
import { Close } from "@mui/icons-material";
import LinkHandler from "./LinkHandler";

const StickyStripe = () => {
  const hasWindow = useHasWindow();
  const theme = useTheme();
  const [showBanner, setShowBanner] = useState(true);

  const {
    allPrismicBanner: { edges },
  } = useStaticQuery(graphql`
    {
      allPrismicBanner {
        edges {
          node {
            uid
            data {
              text {
                html
              }
              start_date
              end_date
              cta_text {
                text
              }
              cta_link {
                link_type
                url
                target
              }
            }
          }
        }
      }
    }
  `);

  const stripesListDueDate = useMemo(() => {
    return edges.filter((item) =>
      isBannerDateActual(item.node.data.start_date, item.node.data.end_date)
    );
  }, [edges]);

  const stripesToShow = useMemo(() => {
    return stripesListDueDate
      .filter(
        (stripe) =>
          typeof window !== "undefined" &&
          !localStorage.getItem(stripe.node.uid)
      )
      .map((stripe) => stripe.node.uid);
  }, [stripesListDueDate]);

  const closeBanner = (id) => {
    localStorage.setItem(id, new Date());
    setShowBanner(false);
  };

  return hasWindow ? (
    <>
      {showBanner && stripesToShow.length > 0 && (
        <>
          {stripesListDueDate.map((item) => (
            <Stack
              key={item.node.uid}
              direction="row"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                height: "60px",
                backgroundColor: theme.palette.accent.main,
                paddingRight: "24px",
                px: "10px",
              }}
            >
              <Stack
                sx={{ ml: "auto", alignItems: "center" }}
                direction="row"
                gap={3}
              >
                {item?.node?.data?.text && (
                  <Box
                    sx={{
                      "&>p": {
                        fontWeight: 700,
                        fontSize: { xs: "12px", md: "14px" },
                        color: "#ffffff",
                        "&>a": {
                          textDecoration: "none",
                          color: "#24242c",
                          "&:hover": {
                            color: "#ffffff",
                            textDecoration: "underline",
                          },
                        },
                      },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: item?.node?.data?.text.html,
                    }}
                  />
                )}

                <LinkHandler
                  caption={item.node.data.cta_text}
                  link={item.node.data.cta_link}
                />
              </Stack>

              <IconButton
                size="small"
                sx={{ color: "#ffffff", ml: "auto" }}
                onClick={() => closeBanner(item.node.uid)}
              >
                <Close fontSize="20px" />
              </IconButton>
            </Stack>
          ))}
        </>
      )}
    </>
  ) : (
    <></>
  );
};

export default StickyStripe;
